module.exports = __webpack_public_path__ + "img/bg.6c3dcf0c.jpg";